export default __webpack_public_path__ + "static/media/americanExpress.a3bea0bd.svg";